<template>
  <DxPopup
    :visible="popupVisible"
    :drag-enabled="false"
    :hide-on-outside-click="false"
    :show-title="false"
    title="Roam Despatch"
    :showCloseButton="false"
    :wrapperAttr="{
      class: 'css-v2 gc-popup gc-popup-roam-despatch-order-batch-details',
    }"
    :fullScreen="true"
    :height="'100%'"
    @shown="popupShown"
  >
    <div class="toolbar">
      <div>
        <div>
          <span class="text-primary">
            {{ popUpData.data.ItemDescription }}</span
          >
          <span class="text-secondary"> {{ popUpData.data.ItemCode }}</span>
        </div>
        <div>
          <span class="text-secondary">
            {{ popUpData.data.UnitOfMeasureCode }}
          </span>
        </div>
      </div>
    </div>

    <div class="form-data toolbar">
      <div>
        <span>
          {{ popUpData.data.StockUMPickedQty }} /
          {{ popUpData.data.StockUMBackorderQty }}</span
        >
      </div>
      <div class="dx-field">
        <div class="dx-field-label">Complete</div>
        <div class="dx-field-value">
          <DxCheckBox
            :value="popUpData.data.Completed"
            :readOnly="
              popUpData.data.StockUMPickedQty >=
              popUpData.data.StockUMBackorderQty
            "
            @valueChanged="onCheckBoxValueChanged"
          />
        </div>
      </div>
    </div>

    <div class="data-grid">
      <dx-data-grid
        :columns="getColumns"
        :data-source="getDataSource"
        @toolbar-preparing="onToolbarPreparing($event)"
        :height="dataGridHeight"
        :key-expr="'BatchNo'"
      >
        <DxEditing
          :allow-updating="true"
          :allow-deleting="false"
          mode="cell"
          :select-text-on-edit-start="true"
        />
      </dx-data-grid>
    </div>

    <div class="footer" :class="'multi-btn gc-data-grid'">
      <DxButton
        :text="'Update'"
        type="success"
        styling-mode="contained"
        @click="onUpdate"
        :disabled="!enabledSave"
      />
      <DxButton
        :text="'Cancel'"
        type="default"
        styling-mode="contained"
        @click="onClickBackButton"
      />
    </div>
  </DxPopup>
</template>

<script>
import BaseViewMixin from "../../v1/_mixins/base.view";
import RouteMixin from "@/_mixins/route.mixin";

export default {
  props: {
    popupVisible: Boolean,
    popUpData: {
      type: Object,
      default: () => {},
    },
  },
  mixins: [BaseViewMixin, RouteMixin],
  data() {
    return {
      dataGridHeight: "auto",
      enabledSave: false,
      completedValue: undefined,
    };
  },
  async created() {},
  computed: {
    getColumns() {
      return [
        {
          caption: "Batch",
          dataField: "BatchNo",
          allowEditing: false,
        },
        {
          caption: "Allocated",
          dataField: "AllocatedQty",
          allowEditing: false,
        },
        {
          caption: "Picked",
          dataField: "Qty",
          showEditorAlways: this.baseView.mode != "review",
          cssClass: "edit-cell-numberbox-field",
          editorOptions: {
            onFocusIn: (e) => {
              e.event.target.select();
            },
            step: 0,
            min: 0,
          },
          setCellValue: async (newData, value, currentRowData) => {
            if (
              value >
              currentRowData.AllocatedQty + currentRowData.AvailableQty
            ) {
              await this.$alert(
                `${this.popUpData.data.ItemDescription} only has ${
                  currentRowData.AllocatedQty + currentRowData.AvailableQty
                } left to pick.  Please enter in a picked quantity that is ${
                  currentRowData.AllocatedQty + currentRowData.AvailableQty
                } or less.`,
                "Error"
              );
              value = currentRowData.AllocatedQty + currentRowData.AvailableQty;
            }

            var that = this;
            that.enabledSave = false;
            newData.Qty = value;
            that.popUpData.data.StockUMPickedQty =
              this.popUpData.data.StockUMPickedQty - currentRowData.Qty + value;

            if (
              !this.popUpData.pickingSettings.allowPartPicking &&
              this.popUpData.data.StockUMPickedQty <
                this.popUpData.data.StockUMBackorderQty
            ) {
              this.displayGenericAlert(
                `The picked quantity must equal the outstanding quantity. Please rectify this before updating this line.`
              );

              return;
            }

            if (
              !this.popUpData.pickingSettings.allowOverPicking &&
              this.popUpData.data.StockUMPickedQty >
                this.popUpData.data.StockUMBackorderQty
            ) {
              let confirmLeaving = await this.$confirm(
                "You cannot over pick the order quantity. Do you wish to continue?",
                "Validation"
              );
              if (confirmLeaving) {
                that.popUpData.data.StockUMPickedQty =
                  this.popUpData.data.StockUMPickedQty +
                  currentRowData.Qty -
                  value;
                newData.Qty = currentRowData.Qty;
              } else {
                newData.Qty = 0;
                that.popUpData.data.StockUMPickedQty =
                  this.popUpData.data.StockUMPickedQty - value + newData.Qty;
              }
            } else if (
              this.popUpData.pickingSettings.allowOverPicking &&
              this.popUpData.data.StockUMPickedQty >
                this.popUpData.data.StockUMBackorderQty
            ) {
              let confirmLeaving = await this.$confirm(
                "You have over picked the order quantity. Do you wish to continue?",
                "Validation"
              );
              if (!confirmLeaving) {
                newData.Qty = 0;
                that.popUpData.data.StockUMPickedQty =
                  this.popUpData.data.StockUMPickedQty - value + newData.Qty;
              } else {
                that.enabledSave = true;
              }
            } else {
              that.enabledSave = true;
            }

            if (
              this.popUpData.data.StockUMPickedQty >=
              this.popUpData.data.StockUMBackorderQty
            )
              that.popUpData.data.Completed = true;
            else that.popUpData.data.Completed = false;
          },
        },
        {
          caption: "Available",
          dataField: "AvailableQty",
          allowEditing: false,
        },
      ];
    },
    getDataSource() {
      var items = [];
      var that = this;

      if (this.popUpData.data.LoadBatchDataSource == false) {
        that.popUpData.data.LoadBatchDataSource = true;
        this.popUpData.po_batchData.forEach((element) => {
          element.AllocatedQty = 0;
          element.Qty = element.AllocatedQty;
          if (element.ItemCode == this.popUpData.data.ItemCode) {
            var index = this.popUpData.data.ChildDataSource.findIndex(
              (i) => i.BatchNo == element.BatchNo
            );
            if (index == -1) {
              items.push(element);
            }
          }
        });

        that.popUpData.data.ChildDataSource =
          that.popUpData.data.ChildDataSource.concat(items);
      }

      return this.popUpData.data.ChildDataSource;
    },
    getStockUMPickedQty() {
      var total = 0;
      this.getDataSource.forEach((element) => {
        total = total + element.Qty;
      });

      return total;
    },
  },
  watch: {},
  methods: {
    onCheckBoxValueChanged(e) {
      if (this.completedValue == undefined)
        this.completedValue = e.previousValue;

      if (this.completedValue != e.value) this.enabledSave = true;

      this.popUpData.data.Completed = e.value;
    },
    onToolbarPreparing(e) {
      e.toolbarOptions.visible = false;
    },
    popupShown() {
      this.dataGridHeight =
        document.querySelectorAll(
          ".gc-popup-roam-despatch-order-batch-details .dx-popup-content"
        )[0].clientHeight - 180;
    },
    onUpdate() {
      this.popUpData.callBack(false, this.popUpData.data);
    },
    onClickBackButton() {
      this.popUpData.callBack(true);
    },
  },
};
</script>

<style lang="scss">
.edit-product-item-popup-footer {
  padding-top: 10px;
  bottom: 0;
  margin-right: 0px;
  height: 45px;
  text-align: right;

  .save-btn {
    margin-right: 10px;
    background-color: #8bc34a;
  }

  .cancel-btn {
    margin-right: 0px;
    background-color: #ff0033;
  }
}

.gc-popup-roam-despatch-order-batch-details {
  .dx-popup-content {
    padding: 10px !important;
    .toolbar {
      background-color: white;
      padding: 12px;
      display: inline-flex;
      flex-direction: row;
      justify-content: space-between;
      width: 100%;
      align-items: center;
      height: 50px;

      .text-primary {
        font-size: 13px !important;
        padding-right: 5px;
      }
      .text-secondary {
        font-size: 12px !important;
      }
    }

    .form-data {
      background-color: white;
      padding: 10px;
      margin-top: 10px;
      height: 50px;

      > div {
        width: 60%;
      }

      .dx-field {
        display: inline-flex;
        width: 40%;
        height: 30px;
        align-items: center;
        justify-content: space-between;
        .dx-field-label {
          color: black !important;
          width: 100%;
        }
      }
    }

    .data-grid {
      padding-top: 10px;
      padding-bottom: 10px;
      .dx-datagrid-header-panel,
      .dx-datagrid-pager {
        display: none !important;
      }

      .dx-datagrid
        .dx-datagrid-content
        .dx-datagrid-table
        .dx-row
        > td:last-of-type:not(.dx-command-expand) {
        padding-right: 18px !important;
      }
    }

    .footer {
      padding-left: 0 !important;
      padding-right: 0 !important;
    }
  }
}
</style>
